import classes from "./VehicleCard.module.css";
import editIcon from "../../images/editIconGray.svg";
import deleteIcon from "../../images/deleteIconGray.svg";
import placeholderVan from "../../images/placeholderVan.jpg";
import { apiUrl } from "../../constants";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import {
  setIsDeleteVehicleShown,
  setIsEditMode,
  setSelectedDataForEdit,
} from "../../redux/globalFunctions/globalFnSlice";

export function VehicleCard({
  img,
  carName,
  driver,
  carRegPlate,
  dimensions,
  data,
  index,
  width,
  height,
  depth,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslations();

  function handleEditClick() {
    dispatch(setSelectedDataForEdit(data));
    dispatch(setIsEditMode(true));
    navigate(`/edit-vehicle/${index + 1}`);
  }

  function handleDeleteClick() {
    dispatch(setSelectedDataForEdit(data));
    dispatch(setIsDeleteVehicleShown(true));
  }

  return (
    <div className={classes.card}>
      <div className={classes.buttons}>
        <button onClick={handleEditClick}>
          <img src={editIcon} alt="" />
        </button>
        <button onClick={handleDeleteClick}>
          <img src={deleteIcon} alt="" />
        </button>
      </div>

      <img
        src={
          img[0]
            ? `${apiUrl.replace(/\/+$/, "")}/${img[0]
                .replace(/^\/+/, "")
                .replace(/\/{2,}/g, "/")}`
            : placeholderVan
        }
        alt=""
      />

      <div className={classes.header}>
        <h4>{carName}</h4>
        <span>
          {driver === null ? (
            <button className={classes.assignBtn} onClick={handleEditClick}>
              {t.addVehicle.assign}
            </button>
          ) : (
            driver
          )}
        </span>
      </div>
      <p>{carRegPlate}</p>
      <p>
        {t.addVehicle.trunkDimensions}{" "}
        {width +
          "x" +
          height +
          "x" +
          depth +
          "m" +
          ";" +
          " " +
          dimensions +
          "cm³"}
      </p>
    </div>
  );
}
